document.addEventListener('DOMContentLoaded', function () {
  console.log("ok");
  
  const toggleSwitch = document.getElementById('toggle');
  const tableCells = document.querySelectorAll('td[data-cm][data-inch]');
  const positionHeader = document.querySelector('.position-header');
  const positionCells = document.querySelectorAll('.position-cell');
  const openButton = document.getElementById('open-size-guide');
  const popup = document.getElementById('size-guide-popup');
  const closeButton = popup.querySelector('.close-btn');
  const bg = document.getElementById('black-bg-2');


  if (openButton) {
    openButton.addEventListener('click', function () {
      popup.style.display = 'flex';
      bg.style.display = "block"

    });
  }
    closeButton.addEventListener('click', function() {
    popup.style.display = 'none'; // Hide popup
       bg.style.display = "none"
  });

  bg.addEventListener('click', function() {
      popup.style.display = 'none'; 
      bg.style.display = "none"
  });

});
